'use client'

import { useEffect } from 'react'

import { IconAlertTriangleYellow } from '@/shared/assets/icons'
import { trackDatadogError } from '@/shared/external/datadog'
import { COMMON_ERROR_DESCRIPTION, COMMON_ERROR_TITLE } from '@/shared/lib'
import { Result, withChunkErrorFallback } from '@/shared/ui'

interface IErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

const Error = ({ error, reset }: IErrorProps) => {
  useEffect(() => {
    trackDatadogError(error, { componentName: 'PlaceSearchPageErrorBoundary' })
  }, [error])

  const handleRetry = () => {
    reset()
  }

  return (
    <div className='flex w-dvw h-dvh justify-center items-center'>
      <Result
        icon={<IconAlertTriangleYellow width='48' height='48' />}
        title={COMMON_ERROR_TITLE}
        description={COMMON_ERROR_DESCRIPTION}
        handleRetry={handleRetry}
      />
    </div>
  )
}

export default withChunkErrorFallback(Error, 'PlaceSearchPageErrorBoundary')
